export default {
  SET_LOADINGSTATE: ({ commit }: any, loading: boolean): void => {
    commit('SET_LOADING', loading)
  }
};
